import { useSeatmap } from '../../providers/SeatmapProvider'

export default function PurchaseSidebar({ hasMap, mapPreview, onFindOnMap }) {
  const { showSeatmap } = useSeatmap()
  const openMap = onFindOnMap || showSeatmap

  return (
    <aside className="spp-sidebar">
      {hasMap ? (
        <button
          type="button"
          className="spp-map-card"
          style={
            mapPreview ? { backgroundImage: `url(${mapPreview})` } : undefined
          }
          onClick={openMap}
          disabled={!hasMap}
        >
          <span className="spp-map-card__cta">
            <svg
              width="17"
              height="17"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
            Find on map
          </span>
        </button>
      ) : null}

      <div className="spp-trust-card">
        {[
          {
            t: 'Mobile tickets',
            d: 'Delivered to your account and scanned at the gate.',
          },
          {
            t: 'Buyer protection',
            d: 'Every listing is verified inventory, safe from bots and scalpers.',
          },
          {
            t: 'Prices are all-in',
            d: 'Taxes and fees included on every listing. No surprises at checkout.',
          },
        ].map((item) => (
          <div key={item.t} className="spp-trust-card__row">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              <polyline points="9 12 11 14 15 10" />
            </svg>
            <div>
              <p className="spp-trust-card__title">{item.t}</p>
              <p className="spp-trust-card__desc">{item.d}</p>
            </div>
          </div>
        ))}
      </div>
    </aside>
  )
}
